import * as React from "react";
import "./MethodDesktop.scss";
import MethodArrow from "../MethodArrow/MethodArrow";
import MethodSplitImage from "../MethodSplitImage/MethodSplitImage";
import { Container } from "react-bootstrap";
import MethodNumber from "../MethodNumber/MethodNumber";
import MethodBody from "../MethodBody/MethodBody";
import MethodImage from "../MethodImage/MethodImage";
import MethodTitle from "../MethodTitle/MethodTitle";
import MethodFooter from "../MethodFooter/MethodFooter";
import ScrollContainer from "react-indiana-drag-scroll";
import PropTypes from "prop-types";

const MethodDesktop = (props) => {
  const data = props.data;
  const isFirefoxOnMac =
    typeof window !== "undefined" &&
    !(window.mozInnerScreenX == null) &&
    window.navigator.platform.indexOf("Mac") >= 0;

  return (
    <div className="method-page">
      <div className="method-container">
        <ScrollContainer
          className={`method-outer-wrapper ${isFirefoxOnMac && "is-firefox"}`}
          vertical={false}
          horizontal={true}
        >
          <div className="method-wrapper">
            <MethodTitle title={data && data.title} />
            <MethodNumber
              background={"grey"}
              number={data && data.numbers[7].file.url}
            />
            <MethodSplitImage image={data && data.images1[0]} />
            <MethodBody
              background={"green"}
              text={data && data.text1.text1}
              subtitle={data && data.title1}
              titleAbove={false}
              limitWidth={"80"}
              alignment={"left"}
            />
            <MethodNumber
              background={"green"}
              number={data && data.numbers[6].file.url}
            />
            <MethodImage
              size="big"
              src={data && data.images2[0]}
              background={"black"}
            />
            <MethodBody
              background={"black"}
              text={data && data.text2.text2}
              subtitle={data && data.title2}
              titleAbove={true}
              limitWidth={"50"}
              alignment={"right"}
            />
            <MethodNumber
              background={"black"}
              number={data && data.numbers[5].file.url}
            />
            <MethodImage
              size="small"
              src={data && data.images3[0]}
              background={"black"}
            />
            <MethodBody
              background={"black"}
              text={data && data.text3.text3}
              subtitle={data && data.title3}
              titleAbove={false}
              limitWidth={"100"}
              alignment={"right"}
            />
            <MethodNumber
              background={"grey"}
              number={data && data.numbers[4].file.url}
            />
            <MethodImage
              size="big"
              src={data && data.images4[0]}
              background={"black"}
            />
            <MethodBody
              background={"grey"}
              text={data && data.text4.text4}
              subtitle={data && data.title4}
              titleAbove={true}
              limitWidth={"100"}
              alignment={"right"}
            />
            <Container className="method-desktop-arrow">
              <MethodArrow orientation={"horizontal"} direction={"left"} />
            </Container>
            <MethodFooter lang={props.lang} />
          </div>
        </ScrollContainer>
      </div>
      {/*<div className="method-bottom-container">
        <div className="method-bottom-upper" />
        <div className="method-bottom-lower">
          <div className="method-bottom-image-container">
            <Image src={data && data.bottomImage.file.url} />
          </div>
          <div className="method-desktop-text method-desktop-bottom-text">
            <div>{data && data.bottomText.bottomText}</div>
            <div className="method-text bottom-link">
              <CallToAction
                label={data && data.bottomLinkText.toUpperCase()}
                to={data && data.bottomLinkUrl}
              />
            </div>
          </div>
        </div>
      </div>*/}
    </div>
  );
};

MethodDesktop.propTypes = {
  data: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
};

export default MethodDesktop;
